import React from "react";

// reactstrap components
import { Container, 
         Row, 
         Col,
         Card,
         CardBody,
         CardHeader,
         Button
      } from "reactstrap";

// core components
const items = [
  {
    id: 1,
    icon: "tech_watch-time",
    caption: "Cambio de horarios",
    boton: "Descargar PDF",
    text: "Los horarios de atención han cambiado. Consulte los nuevos horarios en la sección de contacto o descargue la resolución oficial.",
    pdfJson: "/resolucion-horario-2026.json",
    download: "RESOLUCION-CAMBIO-HORARIO-2026.pdf"
  },
  {
    id: 2,
    icon: "business_globe",
    caption: "Notaría Virtual",
    text: "La prestación del servicio notarial a través de medios electrónicos está temporalmente fuera de servicio, hasta tanto la Superintendencia de Notariado y Registro emita autorización.",
    url: "/"
  },
  {
    id: 3,
    caption: "Cotizador online",
    boton: "Cotizar ahora",
    text: "En este módulo podrá realizar las cotizaciones previas a sus escrituras de: Compraventa, Compraventa e hipoteca con particulares y/o entidades financieras, Hipotecas, cancelaciones de hipoteca, matrimonios y sucesiones, entre otras.",
    url: "/cotizar"
  }
];


function Noticias() {

  const [activeIndex, setActiveIndex] = React.useState(0);

  const downloadPdfFromJson = async (jsonUrl, filename) => {
    const response = await fetch(jsonUrl);
    if (!response.ok) {
      throw new Error("No se pudo cargar el archivo");
    }

    const payload = await response.json();
    const binary = atob(payload.data);
    const bytes = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: payload.contentType || "application/pdf" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename || payload.filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  };

  const goTo = (index) => {
    if (index < 0) {
      setActiveIndex(items.length - 1);
    } else if (index >= items.length) {
      setActiveIndex(0);
    } else {
      setActiveIndex(index);
    }
  };

  const item = items[activeIndex];

  return (
    <>
      <div className="section" id="noticias">
        <Container>
          <Row>
            <Col className="ml-auto mr-auto" lg="5">
              <br />
              <Card className="text-center" style={{ margin: "10px", marginBottom: "10px", borderRadius: "15px", border: "1px solid #888888" }}>
                <CardHeader style={{ paddingTop: "20px" }}>
                  <i className="now-ui-icons tech_laptop" style={{ fontSize: "50px", color: "#031425" }}></i>
                </CardHeader>
                <CardBody>
                  <h2 className="title" style={{ color: "#031425", paddingTop: "10px", marginBottom: "0" }}>
                    Noticias
                  </h2>
                </CardBody>
              </Card>
              <Card className="text-center" style={{ margin: "10px", marginBottom: "10px", borderRadius: "15px", border: "1px solid #888888" }}>
                <CardHeader style={{ paddingTop: "15px" }}>
                  <h2 className="title" style={{ color: "#031425", paddingTop: "1px", marginBottom: "5px" }}>
                    Pagos
                  </h2>
                  <p style={{ fontSize: "10pt", color: "#555", marginBottom: "10px" }}>
                    Aquí podrá realizar los pagos de nuestros servicios.
                  </p>
                  <a href="https://api.openpay.co/v1/myrbge2s9nxwb4pmlbby/open-checkout" target="_blank" rel="noopener noreferrer">
                    <img
                      alt="Logo de la aplicación de pagos PSE"
                      style={{ width: "80px" }}
                      src={require("assets/img/notarias/pse.png")}
                    />
                  </a>
                </CardHeader>
              </Card>
              <Card className="text-center" style={{ margin: "10px", marginBottom: "10px", borderRadius: "15px", border: "1px solid #888888" }}>
                <CardHeader style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                  <h2 className="title" style={{ color: "#031425", paddingTop: "1px", marginBottom: "10px" }}>
                    Contador de Visitas
                  </h2>
                  <a href="https://www.contadorvisitasgratis.com" title="contador de visitas para web">
                    <img src="https://counter11.optistats.ovh/private/contadorvisitasgratis.php?c=xs88mn1pfttwfj9czmfrx3hbwzut831k" border="0" title="contador de visitas para web" alt="contador de visitas para web" />
                  </a>
                </CardHeader>
              </Card>
            </Col>
            <Col lg="7">
              <br />
              <Card style={{ borderRadius: "15px", border: "1px solid #888888", overflow: "hidden" }}>
                {/* Imagen o icono */}
                {item.src ? (
                  <div style={{ overflow: "hidden" }}>
                    <img
                      alt={item.caption}
                      src={item.src}
                      style={{
                        width: "100%",
                        height: "220px",
                        objectFit: "cover",
                        display: "block"
                      }}
                    />
                  </div>
                ) : (
                  <CardHeader className="text-center" style={{ paddingTop: "40px", paddingBottom: "0", borderBottom: "none", backgroundColor: "transparent" }}>
                    <i
                      className={`now-ui-icons ${item.icon || "ui-1_bell-53"}`}
                      style={{ fontSize: "60px", color: "#031425" }}
                    ></i>
                  </CardHeader>
                )}

                {/* Contenido */}
                <CardBody className="text-center" style={{ padding: "25px 35px 20px" }}>
                  <h3 className="title" style={{ color: "#031425", marginBottom: "15px" }}>
                    {item.caption}
                  </h3>
                  <p className="card-description" style={{ color: "#555", lineHeight: "1.7", fontSize: "14px" }}>
                    {item.text}
                  </p>
                  {item.boton && (
                    item.pdfJson ? (
                      <Button
                        color="info"
                        className="btn-round"
                        style={{ marginTop: "10px", padding: "11px 35px" }}
                        onClick={() => downloadPdfFromJson(item.pdfJson, item.download)}
                      >
                        <b>{item.boton}</b>
                      </Button>
                    ) : (
                      <a
                        href={item.url}
                        className="btn btn-info btn-round"
                        role="button"
                        style={{ marginTop: "10px", padding: "11px 35px" }}
                        {...(item.download ? { download: item.download } : {})}
                      >
                        <b>{item.boton}</b>
                      </a>
                    )
                  )}
                </CardBody>

                {/* Controles */}
                <div style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingBottom: "20px",
                  gap: "15px"
                }}>
                  <Button
                    className="btn-round btn-icon btn-neutral"
                    color="info"
                    size="sm"
                    onClick={() => goTo(activeIndex - 1)}
                  >
                    <i className="now-ui-icons arrows-1_minimal-left"></i>
                  </Button>

                  {/* Indicadores */}
                  {items.map((_, idx) => (
                    <span
                      key={idx}
                      onClick={() => goTo(idx)}
                      style={{
                        display: "inline-block",
                        width: idx === activeIndex ? "24px" : "10px",
                        height: "10px",
                        borderRadius: "5px",
                        backgroundColor: idx === activeIndex ? "#2CA8FF" : "#ccc",
                        cursor: "pointer",
                        transition: "all 0.3s ease"
                      }}
                    ></span>
                  ))}

                  <Button
                    className="btn-round btn-icon btn-neutral"
                    color="info"
                    size="sm"
                    onClick={() => goTo(activeIndex + 1)}
                  >
                    <i className="now-ui-icons arrows-1_minimal-right"></i>
                  </Button>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Noticias;
